export default __webpack_public_path__ + "static/human_impact-18e155bc49a3e46fc633703660419533.jpg";